module.exports = __webpack_public_path__ + "static/img/icon03.f36a93d4.svg";